import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, Phone, ArrowRight } from 'lucide-react';

export const FinancingBanner = ({ variant = 'home' }) => (
  <section className={variant === 'home' ? 'bg-white py-10' : 'bg-stone-100 pt-16'} data-testid={`financing-banner-${variant}`}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative overflow-hidden rounded-3xl bg-slate-900 text-white px-6 py-8 sm:px-10 flex flex-col md:flex-row md:items-center gap-6">
        <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-emerald-500/20 blur-3xl" aria-hidden="true" />
        <span className="relative shrink-0 w-14 h-14 rounded-2xl bg-emerald-500 flex items-center justify-center">
          <CreditCard size={28} />
        </span>
        <div className="relative flex-1">
          <p className="text-emerald-400 text-xs font-bold uppercase tracking-wider mb-1">Flexible Payment Options</p>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl" data-testid="financing-banner-title">Financing Available</h2>
          <p className="text-stone-300 mt-1">Ask our techs for details. Get the comfort you need now with affordable monthly payments on repairs and new systems.</p>
        </div>
        <div className="relative flex flex-col sm:flex-row gap-3 shrink-0">
          <a href="tel:8592550728" className="btn-primary inline-flex items-center justify-center gap-2" data-testid={`financing-call-btn-${variant}`}>
            <Phone size={18} /> (859) 255-0728
          </a>
          <Link to="/contact" className="inline-flex items-center justify-center gap-2 border border-white/30 rounded-full px-6 py-3 font-semibold hover:bg-white hover:text-slate-900 transition-colors" data-testid={`financing-contact-btn-${variant}`}>
            Ask About Financing <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
